import { render } from "./ErrorServidorContent.vue?vue&type=template&id=79006f72&scoped=true"
import script from "./ErrorServidorContent.vue?vue&type=script&lang=js"
export * from "./ErrorServidorContent.vue?vue&type=script&lang=js"

import "./ErrorServidorContent.vue?vue&type=style&index=0&id=79006f72&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79006f72"]])

export default __exports__